<app-navbar></app-navbar>
<div class="col-12 col-t-12 col-s-12 main">
   <div class="col-12 col-t-12 col-s-12 imageBack">
       <img [src]=imageBack>
       <div class="title"><p class="titleText">REVOLUCIONEMOS LOS PAGOS</p></div>
       <div class="buttons">
           <div class="col-6 col-t-12 col-s-12 button">
               <a mat-button class="buttonint" id="button1" routerLink="/signin">Inicia sesión</a>
           </div>
           <div class="col-6 col-t-12 col-s-12 button">
               <a mat-button class="buttonint" id="button2" routerLink="/register">Únete</a>
           </div>
       </div>
  </div>
  <div class = "col-12 col-t-12 col-s-12 opinionesBox">
       <div class="col-4 col-t-12 col-s-12 opinion">
           <div class="col-6 col-t-6 col-s-6 opinionName">
               <p>Xataka</p>
           </div>
           <div class="col-6 col-t-6 col-s-6 opinionStars">
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
           </div>
           <div class="col-12 col-t-12 col-s-12 opinionDesc">
               <p>"La mejor aplicación para compartir pagos"<br>- selección editores -</p>
           </div>
       </div>
       <div class="col-4 col-t-12 col-s-12 opinion">
           <div class="col-6 col-t-6 col-s-6 opinionName">
               <p>Hipertextual</p>
           </div>
           <div class="col-6 col-t-6 col-s-6 opinionStars">
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
           </div>
           <div class="col-12 col-t-12 col-s-12 opinionDesc">
               <p>"Lo mejor para organizarse en casa"<br>- selección editores -</p>
           </div>
       </div>
       <div class="col-4 col-t-12 col-s-12 opinion">
           <div class="col-6 col-t-6 col-s-6 opinionName">
               <p>PCComponentes</p>
           </div>
           <div class="col-6 col-t-6 col-s-6 opinionStars">
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
               <i class="fas fa-star"></i>
           </div>
           <div class="col-12 col-t-12 col-s-12 opinionDesc">
               <p>"La mayoría de parejas lo agradecerán"<br>- selección editores -</p>
           </div>
       </div>	
  </div>
  <div class="col-12 col-t-12 col-s-12 clientesBox">
      <div class="col-12 col-t-12 col-s-12 textoClientes">
          <p>Nuestros Clientes</p>
      </div>
       <div class="col-4 col-t-4 col-s-12 cliente" >
           <div class="clienteInt" id="cliente1">
               <div class="col-12 col-t-12 col-s-12 clienteImg">
                   <img [src]=mujerMovil1>
               </div>
               <div class="col-12 col-t-12 col-s-12 clienteText">
                   <p>La comodidad que ofrece está aplicación no tiene precio. Te puede ayudar tanto en cenas como compras y repartos en las casa. Imprescindible para mí.</p><br>- Laura -
               </div>
           </div>
       </div>
       <div class="col-4 col-t-4 col-s-12 cliente" id="cliente2" >
           <div class="clienteInt">
               <div class="col-12 col-t-12 col-s-12 clienteImg">
                   <img [src]=hombreMovil>
               </div>
               <div class="col-12 col-t-12 col-s-12 clienteText">
                   <p>Poder dejar la cartera en casa con total tranquilidad. La app es muy fiable y siempre reparte los gastos equitativamente. ¡A seguir mejorandola!</p><br>- Alberto -
               </div>
           </div>
       </div>
       <div class="col-4 col-t-4 col-s-12 cliente" >
           <div class="clienteInt" id="cliente3">
               <div class="col-12 col-t-12 col-s-12 clienteImg">
                   <img [src]=mujerMovil2>
               </div>
               <div class="col-12 col-t-12 col-s-12 clienteText">
                   <p>Puede ser que haya aplicaciones más completas, pero no más útiles. Muy recomentable sobre todo por la noexión con multitud de bancos.</p><br>- Carmen -
               </div>
           </div>
       </div>
  </div>
  <div class="col-12 col-t-12 col-s-12 colaboradoresBox">
   <div class="col-12 col-t-12 col-s-12 tituloColaboradores">
       <p>Nuestros Colaboradores</p>
   </div>
   <div class="col-12 col-t-12 col-s-12 textoColaboradores">
       <div class="col-8 col-t-12 col-s-12 textCol">
           <p>Contamos con numerosos colaboradores para poder ofrecer las mejores experiencia a nuestros usuarios. Desde entidades bancarias, has microservicios y asociados. GroupMon siempre busca ofrecer la máxima calidad en el producto, por ello cada vez se suman más a esta lista. Conformando así una red global, presente en una gran cantidad de países.</p><br><p id="textMot">!No nos conformemos y sigamos revolucionando los pagos¡</p>
       </div>
   </div>
   <div class="col-12 col-t-12 col-s-12 colaboradores">
       <div class="col-3 col-t-3 col-s-6 colaborador">
           <img [src]=bbva>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador">
           <img [src]=santander>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador colab">
           <img [src]=bankAmerica>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador colab">
           <img [src]=ubs>
       </div>
   </div>
   <div class="col-12 col-t-12 col-s-12 colaboradores">
       <div class="col-4 col-t-4 col-s-4 colaborador">
           <img [src]=applePay>
       </div>
       <div class="col-4 col-t-4 col-s-4 colaborador">
           <img [src]=gPay>
       </div>
       <div class="col-4 col-t-4 col-s-4 colaborador">
           <img [src]=paypal>
       </div>
   </div>
   <div class="col-12 col-t-12 col-s-12 colaboradores">
       <div class="col-3 col-t-3 col-s-6 colaborador">
           <img [src]=uc3m>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador">
           <img [src]=bizum>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador colab">
           <img [src]=amazon>
       </div>
       <div class="col-3 col-t-3 col-s-6 colaborador colab">
           <img [src]=visa>
       </div>
   </div>
  </div>
  <div class="col-12 col-t-12 col-s-12 negocioBox">
       <div class="col-6 col-t-12 col-s-12 negocioText">
           <div class="col-8 col-t-12 col-s-12 negText">
               <p>Los constantes comentarios de nuestros usuarios hacen que el equipo de trabajo realice un sercicio impecable. Siguiendo siempre el camino de desarrollar el mejor producto.</p>
           </div>
           <div class="col-6 col-t-7 col-s-7 button">
               <a mat-button class="buttonint" id="button2" routerLink="/register">Únete</a>
           </div>
       </div>
       <div class="col-6 col-t-12 col-s-12  negocioImage">
           <img [src]=business>
       </div>
   </div>
</div>
<app-footer></app-footer>